import { style } from "@vanilla-extract/css";

export const infoIconStyle = style({
  verticalAlign: "middle",
});
